import { RedoFulfillmentLocationSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-location";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { null as zNull } from "zod";

const GetLocationsOutput = z.object({
  locations: z.array(RedoFulfillmentLocationSchema),
});

export const getLocations = unaryRpc({
  name: "getLocations" as const,
  mock: (generated: z.infer<typeof GetLocationsOutput>) => ({
    locations: generated.locations.map((location, index) =>
      index === 0
        ? { ...location, externalId: "mock-default-fulfillment-location" }
        : location,
    ),
  }),
  input: zNull(),
  output: GetLocationsOutput,
});
